import { render, staticRenderFns } from "./StepSpecialities.vue?vue&type=template&id=818f48c6&"
import script from "./StepSpecialities.vue?vue&type=script&lang=js&"
export * from "./StepSpecialities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports